/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_1_4b = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [6.25115674617994, 49.425899029816065],
                        [6.196053444177987, 49.425899029816065],
                        [6.196053444177987, 49.398201055569196],
                        [6.25115674617994, 49.398201055569196],
                        [6.25115674617994, 49.425899029816065]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_1_4b